import React from 'react'
import ReactGA from 'react-ga';

// 初始化 ReactGA（只在浏览器环境下）
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

if (typeof window !== 'undefined' && GA_TRACKING_ID && process.env.NODE_ENV === 'production') {
    ReactGA.initialize(GA_TRACKING_ID);
}

const GaEventsTracker = (category = "event") => {
    const trackEvent = (action = "Click", label = "label") => {
        // 检查是否已初始化
        if (typeof window !== 'undefined' && GA_TRACKING_ID && process.env.NODE_ENV === 'production') {
            ReactGA.event({
                category: category,
                action: action,
                label: label,
            });
        } else {
            // console.log(`[GA Event] ${category} - ${action} - ${label}`);
        }
    };
    return trackEvent;
}

export default GaEventsTracker